import CodeEditor from '../Library/CodeEditor.js';

const initializedTextareas = new WeakSet();

export const initializeLineNumberedTextareas = scope => {
    scope.querySelectorAll('textarea[data-line-numbers]').forEach(textarea => {
        if (initializedTextareas.has(textarea)) {
            return;
        }

        initializedTextareas.add(textarea);

        CodeEditor.attach(textarea);
    });
};
